import type { DesktopApp } from '@/config/desktopApps';

interface DesktopIconProps {
  app: DesktopApp;
  onOpen: (app: DesktopApp) => void;
}

export function DesktopIcon({ app, onOpen }: DesktopIconProps) {
  const isGpt = app.id === 'gpt';
  const isImageIcon = app.icon.startsWith('/');

  return (
    <button
      onDoubleClick={() => onOpen(app)}
      className="desktop-icon flex flex-col items-center justify-center w-20 h-20 text-white hover:bg-[rgba(0,0,128,0.35)] transition-colors"
      aria-label={`Open ${app.label}`}
    >
      {isGpt ? (
        <img
          src="/images/logoerhbestwhte.png"
          alt="ERHgpt"
          className="w-10 h-10 object-contain mb-1 drop-shadow-[0_0_6px_rgba(0,255,65,0.7)] erh-gpt-icon"
        />
      ) : isImageIcon ? (
        <img
          src={app.icon}
          alt={app.label}
          className="w-10 h-10 object-contain mb-1 drop-shadow-[0_0_8px_rgba(255,255,255,0.25)]"
        />
      ) : (
        <span className="text-3xl mb-1">{app.icon}</span>
      )}
      <span className="text-xs text-center leading-tight drop-shadow-[0_1px_1px_rgba(0,0,0,0.8)]">
        {app.label}
      </span>
    </button>
  );
}
